export default __webpack_public_path__ + "static/media/pepperoni.2256f3be.png";